import React from "react";
import { isAuthed } from "../lib/auth";
import LandingPage from "../pages/Landing";
import OverviewPage from "../pages/Overview";

// Root URL "/" behavior:
// - When admin is logged in → show the internal Overview dashboard
// - When any other visitor lands → show the public marketing homepage
// Same URL, two experiences — buyers never see a raw error / redirect.
export default function AuthAwareHome() {
  return isAuthed() ? <OverviewPage /> : <LandingPage />;
}
